import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const CATEGORIES = [
  { name: "Performance & Quality", example: "Work that is not meeting the expected standard" },
  { name: "Accountability & Ownership", example: "Responsibilities being assumed rather than clearly owned" },
  { name: "Deadlines & Execution", example: "Deadlines, delays and planning problems" },
  { name: "Communication", example: "Updates that are unclear, late or missing" },
  { name: "Attendance, Leave & WFH", example: "Attendance, leave and remote-work conversations" },
  { name: "Behaviour & Attitude", example: "Conduct that affects the team or workplace" },
  { name: "Conflict & Teamwork", example: "Friction, collaboration and team issues" },
  { name: "Pay, Promotion & Recognition", example: "Pay, progression and recognition conversations" },
  { name: "Probation, Discipline & Exit", example: "Probation, formal process and employment decisions" },
  { name: "Leadership, Change & Expectations", example: "Changing priorities, scope and expectations" },
];

export function WhatsInside() {
  return (
    <section id="inside" className="border-y border-line bg-surface/60 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="04"
          eyebrow="What's inside"
          title={
            <>
              Ten categories. <em className="font-normal">One hundred situations.</em>
            </>
          }
        />
        <div className="mt-14 grid grid-cols-1 gap-x-12 sm:grid-cols-2">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={Math.min(i * 0.04, 0.3)}>
              <div
                data-testid={`category-row-${i + 1}`}
                className="group flex items-baseline gap-5 border-b border-line py-5 transition-colors duration-300"
              >
                <span className="font-mono text-xs tracking-[0.15em] text-faint">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <p className="font-medium text-ink transition-transform duration-300 group-hover:translate-x-1">
                    {c.name}
                  </p>
                  <p className="mt-1 text-sm text-faint">{c.example}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
